import { PRICING_STRATEGY } from '@schuettflix/interfaces';
import { ProductConfiguration } from '@/shared/models/ContextDataModel/interfaces/entities/product-configuration.ts';
import { PartialAutomaticProductsFormValues } from '../schema/getAutomaticProductsFormSchema.ts';
import { prefillAutomaticProductsForm } from './prefillAutomaticProductsForm.ts';

export function prefillAutomaticPositionForm(
    pricingStrategy: PRICING_STRATEGY,
    productConfigurations: ProductConfiguration[]
): PartialAutomaticProductsFormValues {
    return { ...prefillAutomaticProductsForm(pricingStrategy, productConfigurations), scope: 'POSITION' };
}
